<template>
  <div>
    <div id="cookieBanner" class="grid-container full">
      <div class="grid-x">
        <div class=" small-12 medium-8 cell text-left">
          <div class="textContainer">
            <h3>Your privacy</h3>
          <p>We use cookies to give you the best experience when using our website. For more information please see our
            <a href="https://www.rarerecruitment.co.uk/cookie-policy">Cookie Policy</a>.
          </p>
          </div>
        </div>
        <div class=" small-12 medium-4 cell text-right">
          <div class="buttonContainer">
            <rare-standard-button
              class="accept-button"
              :tabIndex="1"
              :buttonText="'Reject all'"
              :active="'true'"
              :height="'40px'"
              @clicked="rejectCookies"/>
            <rare-standard-button
              class="accept-button"
              :tabIndex="1"
              :buttonText="'Accept all'"
              :active="'true'"
              :height="'40px'"
              @clicked="acceptCookies"/>
          </div>
        </div>
      </div>
    </div>
    <div id="mask">&nbsp;</div>
  </div>
</template>

<script>

import RareStandardButton from 'rare-patternlab/buttons/RareStandardButton';

export default {
  name: 'RareCookieBannerNew',
  components: {
    'rare-standard-button': RareStandardButton,
  },
  methods: {
    acceptCookies() {
      this.$emit('acceptCookies');
    },
    rejectCookies() {
      this.$emit('rejectCookies');
    },
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  #mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.8 );
    z-index: 9980;
  }

  #cookieBanner {
    background-color: #ffffff;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 99999999;
    height: 200px;
    border-top: 2px solid $dark-grey-background;
  }

  .closeIcon {
    float: right;
    cursor: pointer;
  }

  p {
    color: $main-text;
    padding: 0;
    line-height: 35px;
    font-size: 21px;
  }

  a {
    color: $brown-highlight;
    font-size: 21px;
  }

  .textContainer {
    padding: 30px 70px;
  }

  .buttonContainer {
    height:200px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-right: 70px;
  }

  .cookieButton {
    background-color: $green-highlight;
    color: white;
    padding: 0 20px 0 20px;
    border: 1px solid $green-highlight;
    border-radius: 50px;
    text-decoration: none;
    cursor: pointer;
    height: 40px;
    line-height: 40px;
    margin-right: 20px;
  }

  .cookieButton:hover {
    background-color: #ffffff;
    color: $brown-background;
  }

  @media only screen and (min-width: 800px) {
    .accept-button {
      margin-right: 10px;
    }
  }

  @media only screen
  and (min-device-width : 768px)
  and (max-device-width : 1024px)
  and (orientation : portrait) {

  }

  @media only screen and (max-width: 900px) {
    h3 {
      font-weight: bold;
      font-size: 1.7rem;
    }

    #cookieBanner {
      height: auto;
    }

    .textContainer {
      padding: 30px;
    }

    .buttonContainer {
      height: 100%;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 0 30px 0 30px;
      margin-bottom: 40px;
    }

    .accept-button {
      margin-bottom: 20px;
      width: 100% !important;
    }

  }


</style>



// WEBPACK FOOTER //
// src/components/commonSections/RareCookieBannerNew.vue